import { flattenNestedSvg } from '@/utils'

import { FrameText } from './FrameText'
import { MockQr } from './MockQr'
import {
	DEFAULT_FRAME_FONT,
	FRAME_BLACK,
	FRAME_LIGHT_GREY,
	TRANSPARENT_COLOR,
} from './qrFramesConstants'
import { isNormalFrameMode, TQrFrameProps } from './qrFrameTypes'

export const Frame5 = (props: TQrFrameProps) => {
	const qrMarkup = isNormalFrameMode(props) ? props.patternMarkup : undefined
	const frameColor = isNormalFrameMode(props) ? props.frameColor : FRAME_BLACK
	const textColor = isNormalFrameMode(props) ? props.textColor : 'white'
	const qrBackgroundColor = isNormalFrameMode(props)
		? props.patternBackgroundColor
		: FRAME_LIGHT_GREY
	const frameBackgroundColor = isNormalFrameMode(props)
		? props.frameBackgroundColor
		: TRANSPARENT_COLOR

	const getTextY = (fontSize: number) => {
		const boxTop = 62
		const boxHeight = 22
		const centerY = boxTop + boxHeight / 2
		return centerY + fontSize * 0.085
	}

	return (
		<svg viewBox="0 0 64 84" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g id="frame">
				<path
					d="M4 1h56a3 3 0 0 1 3 3v59H1V4a3 3 0 0 1 3-3Z"
					fill={frameBackgroundColor}
					stroke={frameColor}
					strokeWidth={2}
				/>
				<path
					id="qr-background"
					d="M6 10a4 4 0 0 1 4-4h44a4 4 0 0 1 4 4v44a4 4 0 0 1-4 4H10a4 4 0 0 1-4-4z"
					fill={qrBackgroundColor}
				/>
				{qrMarkup ? (
					<g
						dangerouslySetInnerHTML={{
							__html: flattenNestedSvg(qrMarkup, {
								x: 12,
								y: 12,
								width: 40,
								height: 40,
							}),
						}}
					/>
				) : (
					<MockQr x={12} y={12} />
				)}
			</g>
			<g id="text-container">
				<path
					d="M1 63h62v17a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3z"
					fill={frameColor}
				/>
				<path
					d="M1 63h62v17a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3z"
					stroke={frameColor}
					strokeWidth={2}
				/>
				<FrameText
					text={props.text}
					fontSize={props.fontSize}
					textColor={textColor}
					textY={getTextY(props.fontSize)}
					fontFamily={DEFAULT_FRAME_FONT}
				/>
			</g>
		</svg>
	)
}
